import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router/composables';

import NotFound from '~component/NotFound.vue';
import store from '~store';
import Loading from '~widget/LoadingIndicator.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FindVariationPage',
  setup(__props) {

const { getters } = store;
const loading = computed(() => getters.getVariationLoading);
const showVariation = computed(() => getters.getShowVariation);

const route = useRoute();

onMounted((): void => {
  if (showVariation.value) {
    store.dispatch(
      'fetchVariationConfig',
      route.path.replaceAll('/', ''),
    );
  }
});

return { __sfc: true,getters, loading, showVariation, route, NotFound, Loading }
}

})